/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 592:
/***/ ((__unused_webpack_module, exports) => {

  var __webpack_unused_export__;
  exports.aE = removeDiacritics;
  
  var replacementList = [
    {
      base: ' ',
      chars: "\u00A0",
    }, {
      base: '0',
      chars: "\u07C0",
    }, {
      base: 'A',
      chars: "\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F",
    }, {
      base: 'AA',
      chars: "\uA732",
    }, {
      base: 'AE',
      chars: "\u00C6\u01FC\u01E2",
    }, {
      base: 'AO',
      chars: "\uA734",
    }, {
      base: 'AU',
      chars: "\uA736",
    }, {
      base: 'AV',
      chars: "\uA738\uA73A",
    }, {
      base: 'AY',
      chars: "\uA73C",
    }, {
      base: 'B',
      chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181",
    }, {
      base: 'C',
      chars: "\u24b8\uff23\uA73E\u1E08\u0106\u0043\u0108\u010A\u010C\u00C7\u0187\u023B",
    }, {
      base: 'D',
      chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779",
    }, {
      base: 'Dh',
      chars: "\u00D0",
    }, {
      base: 'DZ',
      chars: "\u01F1\u01C4",
    }, {
      base: 'Dz',
      chars: "\u01F2\u01C5",
    }, {
      base: 'E',
      chars: "\u025B\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07",
    }, {
      base: 'F',
      chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B",
    }, {
      base: 'G',
      chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262",
    }, {
      base: 'H',
      chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D",
    }, {
      base: 'I',
      chars: "\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197",
    }, {
      base: 'J',
      chars: "\u24BF\uFF2A\u0134\u0248\u0237",
    }, {
      base: 'K',
      chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2",
    }, {
      base: 'L',
      chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780",
    }, {
      base: 'LJ',
      chars: "\u01C7",
    }, {
      base: 'Lj',
      chars: "\u01C8",
    }, {
      base: 'M',
      chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB",
    }, {
      base: 'N',
      chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E",
    }, {
      base: 'NJ',
      chars: "\u01CA",
    }, {
      base: 'Nj',
      chars: "\u01CB",
    }, {
      base: 'O',
      chars: "\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C",
    }, {
      base: 'OE',
      chars: "\u0152",
    }, {
      base: 'OI',
      chars: "\u01A2",
    }, {
      base: 'OO',
      chars: "\uA74E",
    }, {
      base: 'OU',
      chars: "\u0222",
    }, {
      base: 'P',
      chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754",
    }, {
      base: 'Q',
      chars: "\u24C6\uFF31\uA756\uA758\u024A",
    }, {
      base: 'R',
      chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782",
    }, {
      base: 'S',
      chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784",
    }, {
      base: 'T',
      chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786",
    }, {
      base: 'Th',
      chars: "\u00DE",
    }, {
      base: 'TZ',
      chars: "\uA728",
    }, {
      base: 'U',
      chars: "\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244",
    }, {
      base: 'V',
      chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245",
    }, {
      base: 'VY',
      chars: "\uA760",
    }, {
      base: 'W',
      chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72",
    }, {
      base: 'X',
      chars: "\u24CD\uFF38\u1E8A\u1E8C",
    }, {
      base: 'Y',
      chars: "\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE",
    }, {
      base: 'Z',
      chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762",
    }, {
      base: 'a',
      chars: "\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251",
    }, {
      base: 'aa',
      chars: "\uA733",
    }, {
      base: 'ae',
      chars: "\u00E6\u01FD\u01E3",
    }, {
      base: 'ao',
      chars: "\uA735",
    }, {
      base: 'au',
      chars: "\uA737",
    }, {
      base: 'av',
      chars: "\uA739\uA73B",
    }, {
      base: 'ay',
      chars: "\uA73D",
    }, {
      base: 'b',
      chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182",
    }, {
      base: 'c',
      chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184",
    }, {
      base: 'd',
      chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA",
    }, {
      base: 'dh',
      chars: "\u00F0",
    }, {
      base: 'dz',
      chars: "\u01F3\u01C6",
    }, {
      base: 'e',
      chars: "\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD",
    }, {
      base: 'f',
      chars: "\u24D5\uFF46\u1E1F\u0192",
    }, {
      base: 'ff',
      chars: "\uFB00",
    }, {
      base: 'fi',
      chars: "\uFB01",
    }, {
      base: 'fl',
      chars: "\uFB02",
    }, {
      base: 'ffi',
      chars: "\uFB03",
    }, {
      base: 'ffl',
      chars: "\uFB04",
    }, {
      base: 'g',
      chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79",
    }, {
      base: 'h',
      chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265",
    }, {
      base: 'hv',
      chars: "\u0195",
    }, {
      base: 'i',
      chars: "\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131",
    }, {
      base: 'j',
      chars: "\u24D9\uFF4A\u0135\u01F0\u0249",
    }, {
      base: 'k',
      chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3",
    }, {
      base: 'l',
      chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D",
    }, {
      base: 'lj',
      chars: "\u01C9",
    }, {
      base: 'm',
      chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F",
    }, {
      base: 'n',
      chars: "\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509",
    }, {
      base: 'nj',
      chars: "\u01CC",
    }, {
      base: 'o',
      chars: "\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\uA74B\uA74D\u0275\u0254\u1D11",
    }, {
      base: 'oe',
      chars: "\u0153",
    }, {
      base: 'oi',
      chars: "\u01A3",
    }, {
      base: 'oo',
      chars: "\uA74F",
    }, {
      base: 'ou',
      chars: "\u0223",
    }, {
      base: 'p',
      chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1",
    }, {
      base: 'q',
      chars: "\u24E0\uFF51\u024B\uA757\uA759",
    }, {
      base: 'r',
      chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783",
    }, {
      base: 's',
      chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282",
    }, {
      base: 'ss',
      chars: "\xDF",
    }, {
      base: 't',
      chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787",
    }, {
      base: 'th',
      chars: "\u00FE",
    }, {
      base: 'tz',
      chars: "\uA729",
    }, {
      base: 'u',
      chars: "\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289",
    }, {
      base: 'v',
      chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C",
    }, {
      base: 'vy',
      chars: "\uA761",
    }, {
      base: 'w',
      chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73",
    }, {
      base: 'x',
      chars: "\u24E7\uFF58\u1E8B\u1E8D",
    }, {
      base: 'y',
      chars: "\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF",
    }, {
      base: 'z',
      chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763",
    }
  ];
  
  var diacriticsMap = {};
  for (var i = 0; i < replacementList.length; i += 1) {
    var chars = replacementList[i].chars;
    for (var j = 0; j < chars.length; j += 1) {
      diacriticsMap[chars[j]] = replacementList[i].base;
    }
  }
  
  function removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007e]/g, function(c) {
      return diacriticsMap[c] || c;
    });
  }
  
  __webpack_unused_export__ = replacementList;
  __webpack_unused_export__ = diacriticsMap;
  
  
  /***/ }),
  
  /***/ 664:
  /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
  
  "use strict";
  
  
  const codes = __webpack_require__(896);
  const supportedLocales = __webpack_require__(908);
  const removeDiacritics = (__webpack_require__(592)/* .remove */ .aE);
  const registeredLocales = {};
  
  /*
   * All codes map to ISO 3166-1 alpha-2
   */
  const alpha2 = {},
    alpha3 = {},
    numeric = {},
    invertedNumeric = {};
  
  codes.forEach(function (codeInformation) {
    const s = codeInformation;
    alpha2[s[0]] = s[1];
    alpha3[s[1]] = s[0];
    numeric[s[2]] = s[0];
    invertedNumeric[s[0]] = s[2];
  });
  
  /**
   * @private
   * @param {number} code
   */
  function formatNumericCode(code) {
    return String("000" + (code ? code : "")).slice(-3);
  }
  
  /**
   * @private
   * Avoid using obj.hasOwnProperty directly as `hasOwnProperty` could be a
   * property in itself ({ hasOwnProperty: 1 }) and cause weird bugs
   * https://eslint.org/docs/rules/no-prototype-builtins
   */
  function hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }
  
  /**
   * @private
   * Pass localeList through a filter and return a newLocaleList obj
   * with the same structure of the old localeList.
   *
   * @param {LocalizedCountryNames} localeList  Local List in raw
   * @param {Function} filter    callback to set filter rule
   * @return {String | String[]} new filtered Local List
   */
  function localeFilter(localeList, filter) {
    return Object.keys(localeList).reduce(function (newLocaleList, alpha2) {
      const nameList = localeList[alpha2];
      newLocaleList[alpha2] = filter(nameList, alpha2);
      return newLocaleList;
    }, {});
  }
  
  /**
   * @private
   * Preserve for getName & getNames
   *
   * @param {GetNameOptions.select} type all | official | alias
   * @param countryNameList  string array of country's
   *                         official name and alias
   * @return {String | String[]} of a country name
   */
  function filterNameBy(type, countryNameList) {
    switch (type) {
      case "official":
        return Array.isArray(countryNameList)
          ? countryNameList[0]
          : countryNameList;
  
      case "all":
        return typeof countryNameList === "string"
          ? [countryNameList]
          : countryNameList;
  
      case "alias":
        return Array.isArray(countryNameList)
          ? countryNameList[1] || countryNameList[0]
          : countryNameList;
  
      default:
        throw new TypeError(
          "LocaleNameType must be one of these: all, official, alias!"
        );
    }
  }
  
  /**
   * Register countries in browsers' environment:
   * @param {object} localeData
   * @example countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
   * @return void
   */
  exports.registerLocale = function (localeData) {
    if (!localeData.locale) {
      throw new TypeError("Missing localeData.locale");
    }
  
    if (!localeData.countries) {
      throw new TypeError("Missing localeData.countries");
    }
  
    registeredLocales[localeData.locale] = localeData.countries;
  };
  
  /*
   * @param code Alpha-3 code
   * @return Alpha-2 code or undefined
   */
  function alpha3ToAlpha2(code) {
    return alpha3[code];
  }
  exports.alpha3ToAlpha2 = alpha3ToAlpha2;
  
  /*
   * @param code Alpha-2 code
   * @return Alpha-3 code or undefined
   */
  function alpha2ToAlpha3(code) {
    return alpha2[code];
  }
  exports.alpha2ToAlpha3 = alpha2ToAlpha3;
  
  /*
   * @param code Alpha-3 code
   * @return Numeric code or undefined
   */
  function alpha3ToNumeric(code) {
    return invertedNumeric[alpha3ToAlpha2(code)];
  }
  exports.alpha3ToNumeric = alpha3ToNumeric;
  
  /*
   * @param code Alpha-2 code
   * @return Numeric code or undefined
   */
  function alpha2ToNumeric(code) {
    return invertedNumeric[code];
  }
  exports.alpha2ToNumeric = alpha2ToNumeric;
  
  /*
   * @param code Numeric code
   * @return Alpha-3 code or undefined
   */
  function numericToAlpha3(code) {
    const padded = formatNumericCode(code);
    return alpha2ToAlpha3(numeric[padded]);
  }
  exports.numericToAlpha3 = numericToAlpha3;
  
  /*
   * @param code Numeric code
   * @return Alpha-2 code or undefined
   */
  function numericToAlpha2(code) {
    const padded = formatNumericCode(code);
    return numeric[padded];
  }
  exports.numericToAlpha2 = numericToAlpha2;
  
  /*
   * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
   * @return ISO 3166-1 alpha-3
   */
  function toAlpha3(code) {
    if (typeof code === "string") {
      if (/^[0-9]*$/.test(code)) {
        return numericToAlpha3(code);
      }
      if (code.length === 2) {
        return alpha2ToAlpha3(code.toUpperCase());
      }
      if (code.length === 3) {
        return code.toUpperCase();
      }
    }
    if (typeof code === "number") {
      return numericToAlpha3(code);
    }
    return undefined;
  }
  exports.toAlpha3 = toAlpha3;
  
  /*
   * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
   * @return ISO 3166-1 alpha-2
   */
  function toAlpha2(code) {
    if (typeof code === "string") {
      if (/^[0-9]*$/.test(code)) {
        return numericToAlpha2(code);
      }
      if (code.length === 2) {
        return code.toUpperCase();
      }
      if (code.length === 3) {
        return alpha3ToAlpha2(code.toUpperCase());
      }
    }
    if (typeof code === "number") {
      return numericToAlpha2(code);
    }
    return undefined;
  }
  exports.toAlpha2 = toAlpha2;
  
  /**
   * @param {string | number | Alpha2Code | Alpha3Code} code
   * @param {String} lang          language for country name
   * @param {GetNameOptions} options
   * @return {String | String[] | undefined}  name
   */
  exports.getName = function (code, lang, options = {}) {
    if (!("select" in options)) {
      options.select = "official";
    }
    try {
      const codeMaps = registeredLocales[lang.toLowerCase()];
      const nameList = codeMaps[toAlpha2(code)];
      return filterNameBy(options.select, nameList);
    } catch (err) {
      return undefined;
    }
  };
  
  /**
   * @param {String} lang             language for country names
   * @param {GetNameOptions} options   getNames Options
   * @return {LocalizedCountryNames}  country code
   *                                  mapped to county name
   */
  exports.getNames = function (lang, options = {}) {
    if (!("select" in options)) {
      options.select = "official";
    }
    const localeList = registeredLocales[lang.toLowerCase()];
    if (localeList === undefined) return {};
    return localeFilter(localeList, function (nameList) {
      return filterNameBy(options.select, nameList);
    });
  };
  
  /*
   * @param name name
   * @param lang language for country name
   * @return ISO 3166-1 alpha-2 or undefined
   */
  exports.getAlpha2Code = function (name, lang) {
    const normalizeString = (string) => string.toLowerCase();
    const areSimilar = (a, b) => normalizeString(a) === normalizeString(b);
  
    try {
      const codenames = registeredLocales[lang.toLowerCase()];
      for (const p in codenames) {
        if (!hasOwnProperty(codenames, p)) {
          continue;
        }
        if (typeof codenames[p] === "string") {
          if (areSimilar(codenames[p], name)) {
            return p;
          }
        }
        if (Array.isArray(codenames[p])) {
          for (const mappedName of codenames[p]) {
            if (areSimilar(mappedName, name)) {
              return p;
            }
          }
        }
      }
      return undefined;
    } catch (err) {
      return undefined;
    }
  };
  
  /*
   * @param name name
   * @param lang language for country name
   * @return ISO 3166-1 alpha-2 or undefined
   */
  exports.getSimpleAlpha2Code = function (name, lang) {
    const normalizeString = (string) => removeDiacritics(string.toLowerCase());
    const areSimilar = (a, b) => normalizeString(a) === normalizeString(b);
  
    try {
      const codenames = registeredLocales[lang.toLowerCase()];
      for (const p in codenames) {
        if (!hasOwnProperty(codenames, p)) {
          continue;
        }
        if (typeof codenames[p] === "string") {
          if (areSimilar(codenames[p], name)) {
            return p;
          }
        }
        if (Array.isArray(codenames[p])) {
          for (const mappedName of codenames[p]) {
            if (areSimilar(mappedName, name)) {
              return p;
            }
          }
        }
      }
      return undefined;
    } catch (err) {
      return undefined;
    }
  };
  
  /*
   * @return Object of alpha-2 codes mapped to alpha-3 codes
   */
  exports.getAlpha2Codes = function () {
    return alpha2;
  };
  
  /*
   * @param name name
   * @param lang language for country name
   * @return ISO 3166-1 alpha-3 or undefined
   */
  exports.getAlpha3Code = function (name, lang) {
    const alpha2 = exports.getAlpha2Code(name, lang);
    if (alpha2) {
      return exports.toAlpha3(alpha2);
    } else {
      return undefined;
    }
  };
  
  /*
   * @param name name
   * @param lang language for country name
   * @return ISO 3166-1 alpha-3 or undefined
   */
  exports.getSimpleAlpha3Code = function (name, lang) {
    const alpha2 = exports.getSimpleAlpha2Code(name, lang);
    if (alpha2) {
      return exports.toAlpha3(alpha2);
    } else {
      return undefined;
    }
  };
  
  /*
   * @return Object of alpha-3 codes mapped to alpha-2 codes
   */
  exports.getAlpha3Codes = function () {
    return alpha3;
  };
  
  /*
   * @return Object of numeric codes mapped to alpha-2 codes
   */
  exports.getNumericCodes = function () {
    return numeric;
  };
  
  /*
   * @return Array of registered languages
   */
  exports.langs = function () {
    return Object.keys(registeredLocales);
  };
  
  /*
   * @return Array of supported languages
   */
  exports.getSupportedLanguages = function () {
    return supportedLocales;
  };
  
  /*
   * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
   * @return Boolean
   */
  exports.isValid = function (code) {
    if (!code) {
      return false;
    }
  
    const coerced = code.toString().toUpperCase();
    return (
      hasOwnProperty(alpha3, coerced) ||
      hasOwnProperty(alpha2, coerced) ||
      hasOwnProperty(numeric, coerced)
    );
  };
  
  
  /***/ }),
  
  /***/ 560:
  /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
  
  var map = __webpack_require__(183);
  
  var getCountryCode = function(localeString) {
      var components = localeString.split("_");
      if (components.length == 2) {
          return components.pop();
      }
      components = localeString.split("-");
      if (components.length == 2) {
          return components.pop();
      }
      return localeString;
  }
  
  exports.getCurrency = function(locale) {
      var countryCode = getCountryCode(locale).toUpperCase();
      if (countryCode in map) {
          return map[countryCode];
      }
      return null;
  }
  
  exports.getLocales = function(currencyCode) {
      currencyCode = currencyCode.toUpperCase();
      var locales = [];
      for (countryCode in map) {
          if (map[countryCode] === currencyCode) {
              locales.push(countryCode);
          }
      }
      return locales;
  }
  
  /***/ }),
  
  /***/ 183:
  /***/ ((module) => {
  
  // Generated using ShowCurrencies.java
  var map = {
  AD: 'EUR',
  AE: 'AED',
  AF: 'AFN',
  AG: 'XCD',
  AI: 'XCD',
  AL: 'ALL',
  AM: 'AMD',
  AN: 'ANG',
  AO: 'AOA',
  AR: 'ARS',
  AS: 'USD',
  AT: 'EUR',
  AU: 'AUD',
  AW: 'AWG',
  AX: 'EUR',
  AZ: 'AZN',
  BA: 'BAM',
  BB: 'BBD',
  BD: 'BDT',
  BE: 'EUR',
  BF: 'XOF',
  BG: 'BGN',
  BH: 'BHD',
  BI: 'BIF',
  BJ: 'XOF',
  BL: 'EUR',
  BM: 'BMD',
  BN: 'BND',
  BO: 'BOB',
  BQ: 'USD',
  BR: 'BRL',
  BS: 'BSD',
  BT: 'BTN',
  BV: 'NOK',
  BW: 'BWP',
  BY: 'BYR',
  BZ: 'BZD',
  CA: 'CAD',
  CC: 'AUD',
  CD: 'CDF',
  CF: 'XAF',
  CG: 'XAF',
  CH: 'CHF',
  CI: 'XOF',
  CK: 'NZD',
  CL: 'CLP',
  CM: 'XAF',
  CN: 'CNY',
  CO: 'COP',
  CR: 'CRC',
  CU: 'CUP',
  CV: 'CVE',
  CW: 'ANG',
  CX: 'AUD',
  CY: 'EUR',
  CZ: 'CZK',
  DE: 'EUR',
  DJ: 'DJF',
  DK: 'DKK',
  DM: 'XCD',
  DO: 'DOP',
  DZ: 'DZD',
  EC: 'USD',
  EE: 'EUR',
  EG: 'EGP',
  EH: 'MAD',
  ER: 'ERN',
  ES: 'EUR',
  ET: 'ETB',
  FI: 'EUR',
  FJ: 'FJD',
  FK: 'FKP',
  FM: 'USD',
  FO: 'DKK',
  FR: 'EUR',
  GA: 'XAF',
  GB: 'GBP',
  GD: 'XCD',
  GE: 'GEL',
  GF: 'EUR',
  GG: 'GBP',
  GH: 'GHS',
  GI: 'GIP',
  GL: 'DKK',
  GM: 'GMD',
  GN: 'GNF',
  GP: 'EUR',
  GQ: 'XAF',
  GR: 'EUR',
  GS: 'GBP',
  GT: 'GTQ',
  GU: 'USD',
  GW: 'XOF',
  GY: 'GYD',
  HK: 'HKD',
  HM: 'AUD',
  HN: 'HNL',
  HR: 'HRK',
  HT: 'HTG',
  HU: 'HUF',
  ID: 'IDR',
  IE: 'EUR',
  IL: 'ILS',
  IM: 'GBP',
  IN: 'INR',
  IO: 'USD',
  IQ: 'IQD',
  IR: 'IRR',
  IS: 'ISK',
  IT: 'EUR',
  JE: 'GBP',
  JM: 'JMD',
  JO: 'JOD',
  JP: 'JPY',
  KE: 'KES',
  KG: 'KGS',
  KH: 'KHR',
  KI: 'AUD',
  KM: 'KMF',
  KN: 'XCD',
  KP: 'KPW',
  KR: 'KRW',
  KW: 'KWD',
  KY: 'KYD',
  KZ: 'KZT',
  LA: 'LAK',
  LB: 'LBP',
  LC: 'XCD',
  LI: 'CHF',
  LK: 'LKR',
  LR: 'LRD',
  LS: 'LSL',
  LT: 'LTL',
  LU: 'EUR',
  LV: 'LVL',
  LY: 'LYD',
  MA: 'MAD',
  MC: 'EUR',
  MD: 'MDL',
  ME: 'EUR',
  MF: 'EUR',
  MG: 'MGA',
  MH: 'USD',
  MK: 'MKD',
  ML: 'XOF',
  MM: 'MMK',
  MN: 'MNT',
  MO: 'MOP',
  MP: 'USD',
  MQ: 'EUR',
  MR: 'MRO',
  MS: 'XCD',
  MT: 'EUR',
  MU: 'MUR',
  MV: 'MVR',
  MW: 'MWK',
  MX: 'MXN',
  MY: 'MYR',
  MZ: 'MZN',
  NA: 'NAD',
  NC: 'XPF',
  NE: 'XOF',
  NF: 'AUD',
  NG: 'NGN',
  NI: 'NIO',
  NL: 'EUR',
  NO: 'NOK',
  NP: 'NPR',
  NR: 'AUD',
  NU: 'NZD',
  NZ: 'NZD',
  OM: 'OMR',
  PA: 'PAB',
  PE: 'PEN',
  PF: 'XPF',
  PG: 'PGK',
  PH: 'PHP',
  PK: 'PKR',
  PL: 'PLN',
  PM: 'EUR',
  PN: 'NZD',
  PR: 'USD',
  PS: 'ILS',
  PT: 'EUR',
  PW: 'USD',
  PY: 'PYG',
  QA: 'QAR',
  RE: 'EUR',
  RO: 'RON',
  RS: 'RSD',
  RU: 'RUB',
  RW: 'RWF',
  SA: 'SAR',
  SB: 'SBD',
  SC: 'SCR',
  SD: 'SDG',
  SE: 'SEK',
  SG: 'SGD',
  SH: 'SHP',
  SI: 'EUR',
  SJ: 'NOK',
  SK: 'EUR',
  SL: 'SLL',
  SM: 'EUR',
  SN: 'XOF',
  SO: 'SOS',
  SR: 'SRD',
  ST: 'STD',
  SV: 'SVC',
  SX: 'ANG',
  SY: 'SYP',
  SZ: 'SZL',
  TC: 'USD',
  TD: 'XAF',
  TF: 'EUR',
  TG: 'XOF',
  TH: 'THB',
  TJ: 'TJS',
  TK: 'NZD',
  TL: 'USD',
  TM: 'TMT',
  TN: 'TND',
  TO: 'TOP',
  TR: 'TRY',
  TT: 'TTD',
  TV: 'AUD',
  TW: 'TWD',
  TZ: 'TZS',
  UA: 'UAH',
  UG: 'UGX',
  UM: 'USD',
  US: 'USD',
  UY: 'UYU',
  UZ: 'UZS',
  VA: 'EUR',
  VC: 'XCD',
  VE: 'VEF',
  VG: 'USD',
  VI: 'USD',
  VN: 'VND',
  VU: 'VUV',
  WF: 'XPF',
  WS: 'WST',
  YE: 'YER',
  YT: 'EUR',
  ZA: 'ZAR',
  ZM: 'ZMK',
  ZW: 'ZWL'
  };
  
  module.exports = map;
  
  /***/ }),
  
  /***/ 896:
  /***/ ((module) => {
  
  "use strict";
  module.exports = /*#__PURE__*/JSON.parse('[["AF","AFG","004","ISO 3166-2:AF"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["MK","MKD","807","ISO 3166-2:MK"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["AX","ALA","248","ISO 3166-2:AX"],["BQ","BES","535","ISO 3166-2:BQ"],["CW","CUW","531","ISO 3166-2:CW"],["GG","GGY","831","ISO 3166-2:GG"],["IM","IMN","833","ISO 3166-2:IM"],["JE","JEY","832","ISO 3166-2:JE"],["ME","MNE","499","ISO 3166-2:ME"],["BL","BLM","652","ISO 3166-2:BL"],["MF","MAF","663","ISO 3166-2:MF"],["RS","SRB","688","ISO 3166-2:RS"],["SX","SXM","534","ISO 3166-2:SX"],["SS","SSD","728","ISO 3166-2:SS"],["XK","XXK","983","ISO 3166-2:XK"]]');
  
  /***/ }),
  
  /***/ 616:
  /***/ ((module) => {
  
  "use strict";
  module.exports = /*#__PURE__*/JSON.parse('{"locale":"en","countries":{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":["People\'s Republic of China","China"],"CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":["Republic of the Congo","Congo"],"CD":["Democratic Republic of the Congo","Congo"],"CK":"Cook Islands","CR":"Costa Rica","CI":["Cote d\'Ivoire","Côte d\'Ivoire","Ivory Coast"],"HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":["Czech Republic","Czechia"],"DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":["Republic of The Gambia","The Gambia","Gambia"],"GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":["Islamic Republic of Iran","Iran"],"IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"North Korea","KR":["South Korea","Korea, Republic of","Republic of Korea"],"KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\'s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MK":["The Republic of North Macedonia","North Macedonia"],"MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":["State of Palestine","Palestine"],"PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":["Pitcairn","Pitcairn Islands"],"PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":["Russian Federation","Russia"],"RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Eswatini","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":["Taiwan, Province of China","Taiwan"],"TJ":"Tajikistan","TZ":["United Republic of Tanzania","Tanzania"],"TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":["Türkiye","Turkey"],"TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":["United Arab Emirates","UAE"],"GB":["United Kingdom","UK","Great Britain"],"US":["United States of America","United States","USA","U.S.A.","US","U.S."],"UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe","AX":["Åland Islands","Aland Islands"],"BQ":"Bonaire, Sint Eustatius and Saba","CW":"Curaçao","GG":"Guernsey","IM":"Isle of Man","JE":"Jersey","ME":"Montenegro","BL":"Saint Barthélemy","MF":"Saint Martin (French part)","RS":"Serbia","SX":"Sint Maarten (Dutch part)","SS":"South Sudan","XK":"Kosovo"}}');
  
  /***/ }),
  
  /***/ 908:
  /***/ ((module) => {
  
  "use strict";
  module.exports = /*#__PURE__*/JSON.parse('["br","cy","dv","sw","eu","af","am","ha","ku","ml","no","ps","sd","so","sq","ta","tg","tt","ug","ur","vi","ar","az","be","bg","bn","bs","ca","cs","da","de","el","en","es","et","fa","fi","fr","ga","gl","he","hi","hr","hu","hy","id","is","it","ja","ka","kk","km","ko","ky","lt","lv","mk","mn","mr","ms","nb","nl","nn","pl","pt","ro","ru","sk","sl","sr","sv","th","tr","uk","uz","zh"]');
  
  /***/ })
  
  /******/ 	});
  /************************************************************************/
  /******/ 	// The module cache
  /******/ 	var __webpack_module_cache__ = {};
  /******/ 	
  /******/ 	// The require function
  /******/ 	function __webpack_require__(moduleId) {
  /******/ 		// Check if module is in cache
  /******/ 		var cachedModule = __webpack_module_cache__[moduleId];
  /******/ 		if (cachedModule !== undefined) {
  /******/ 			return cachedModule.exports;
  /******/ 		}
  /******/ 		// Create a new module (and put it into the cache)
  /******/ 		var module = __webpack_module_cache__[moduleId] = {
  /******/ 			// no module.id needed
  /******/ 			// no module.loaded needed
  /******/ 			exports: {}
  /******/ 		};
  /******/ 	
  /******/ 		// Execute the module function
  /******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
  /******/ 	
  /******/ 		// Return the exports of the module
  /******/ 		return module.exports;
  /******/ 	}
  /******/ 	
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (() => {
  "use strict";
  /* harmony import */ var locale_currency__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(560);
  /* harmony import */ var i18n_iso_countries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(664);
  

class FreeShippingMsg extends HTMLElement {
    constructor() {
        super();

        this.smallEl = this.querySelector('small[data-free-shipping]');
        this.progressEl = this.querySelector('div[data-free-shipping-progress]');
        this.defaultCurrency = this.smallEl.getAttribute('data-free-shipping-default-currency');
        // Active Shopify market/country — primary signal for threshold lookup
        this.marketCountry = (this.smallEl.getAttribute('data-market-country') || '').toLowerCase();

        this.freeShipMinReg1Code = (this.smallEl.getAttribute('data-free-shipping-min-reg1-code') || '').toLowerCase();
        this.freeShipMinReg1 = this.parseThresholdAttribute('data-free-shipping-min-reg1');
        this.freeShipExpReg1 = this.parseThresholdAttribute('data-free-shipping-exp-reg1');

        this.freeShipMinReg2Code = (this.smallEl.getAttribute('data-free-shipping-min-reg2-code') || '').toLowerCase();
        this.freeShipMinReg2 = this.parseThresholdAttribute('data-free-shipping-min-reg2');
        this.freeShipExpReg2 = this.parseThresholdAttribute('data-free-shipping-exp-reg2');

        this.freeShipMinReg3Code = (this.smallEl.getAttribute('data-free-shipping-min-reg3-code') || '').toLowerCase();
        this.freeShipMinReg3 = this.parseThresholdAttribute('data-free-shipping-min-reg3');
        this.freeShipExpReg3 = this.parseThresholdAttribute('data-free-shipping-exp-reg3');
        this.cartTotal = parseFloat(this.smallEl.getAttribute('data-cart-total'))/100;

        this.shippingEstimateEl = this.querySelector('[data-shipping-estimate]')
          || this.closest('cart-drawer')?.querySelector('.drawer__footer [data-shipping-estimate]');
        this.shippingEstimateEnabled = Boolean(this.shippingEstimateEl);
        this.cart = JSON.parse(this.querySelector('script[data-cart]').textContent);

        this.progressSetting = this.smallEl.getAttribute('data-free-shipping-progress');
        this.svg = this.smallEl.getAttribute('data-svg');
        this.mlistFreeShippingMsg = this.smallEl.getAttribute('data-mlist-free-shipping-msg');
        this.mlistFreeShippingEnabled = this.smallEl.getAttribute('data-mlist-free-shipping-enable') === 'true';
        this.mlistFreeShippingCountries = this.parseListAttribute('data-mlist-free-shipping-countries');
        this.mlistFreeShippingTiers = this.parseListAttribute('data-mlist-free-shipping-tiers');
        this.init();

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: this.cart }));
    }

    parseListAttribute(attribute) {
        const value = this.smallEl.getAttribute(attribute);
        if (!value) return [];
        return value.split(',').map((item) => item.trim()).filter(Boolean);
    }

    /**
     * Parse a cents threshold from a data attribute.
     * Blank / missing / non-numeric → null (means "not configured").
     * Liquid often coerces a blank setting through `| times: 100` to 0 — treat 0 as unset for express.
     */
    parseThresholdAttribute(attribute) {
        const raw = this.smallEl.getAttribute(attribute);
        if (raw === null || raw === '') return null;
        const cents = parseFloat(raw);
        if (!Number.isFinite(cents)) return null;
        return cents / 100;
    }

    /** Convert a shop-currency threshold into the presentment currency. */
    toPresentmentAmount(amountInShopCurrency) {
        if (!Number.isFinite(amountInShopCurrency)) return null;
        const currentCurrency = Shopify.currency?.active;
        const exchangeRate = Number(Shopify.currency?.rate);
        if (currentCurrency && currentCurrency !== this.defaultCurrency && Number.isFinite(exchangeRate)) {
          return amountInShopCurrency * exchangeRate;
        }
        return amountInShopCurrency;
    }

    /** Explicit: only a finite positive threshold means free express is offered. */
    hasFreeExpress(exp) {
        return Number.isFinite(exp) && exp > 0;
    }

    /**
     * Threshold lookup country: active market first, geo-IP session value as fallback only.
     * Geo-IP remains used elsewhere for EDD address (province/zip).
     */
    getThresholdCountry() {
        if (this.marketCountry) return this.marketCountry;
        return (sessionStorage.getItem('customerLocationCode') || '').toLowerCase();
    }

    hasMlistFreeShipping() {
        if (!this.mlistFreeShippingEnabled || !window.customer?.isLoggedIn) return false;
        const tags = window.customer.tags || [];
        return this.mlistFreeShippingTiers.some((tier) => tags.includes(`swell_vip_${tier}`));
    }

    isMlistFreeShippingCountry(country) {
        return this.mlistFreeShippingCountries.includes(country);
    }

    getShippingConfigForCountry(country) {
        if (this.freeShipMinReg1Code === country) {
          return { min: this.freeShipMinReg1, exp: this.freeShipExpReg1 };
        }
        if (this.freeShipMinReg2Code === country) {
          return { min: this.freeShipMinReg2, exp: this.freeShipExpReg2 };
        }
        if (this.freeShipMinReg3Code === country) {
          return { min: this.freeShipMinReg3, exp: this.freeShipExpReg3 };
        }
        return null;
    }

    async init() {
      // Market-aware messaging does not need geo-IP; paint ASAP when market is known.
      if (this.marketCountry) {
        this.setMsg();
      }

      /**
       * If we have already checked the currency of the user in this session return
       */
      const checkedCurrency = Boolean(sessionStorage.getItem('customerLocationCurrency'));
      const checkedCountry = Boolean(sessionStorage.getItem('customerLocationCode'));
      const checkedProvince = Boolean(sessionStorage.getItem('customerProvince'));
      const checkedZip = Boolean(sessionStorage.getItem('customerZip'));
      if (checkedCurrency && checkedZip && checkedCountry && checkedProvince && this.cart) {
        console.debug('Currency already checked');
        this.setMsg();
        return;
      }
  
      /**
       * Get the users location with maxmind — used for EDD shipping address (province/zip)
       * and as a fallback country when market country is unavailable.
       */
      try {
        const location = await this.getCustomerLocation();
        if (location) {
          sessionStorage.setItem('customerLocationCode', location.customerCountry);
          sessionStorage.setItem('customerProvince', location.customerProvince);
          sessionStorage.setItem('customerZip', location.customerZip);
        }
      } catch (error) {
        console.debug('GeoIP lookup failed for free shipping message', error);
      }
      this.setMsg();


    }

    async getCustomerLocation() {
      /**
       * Requires maxmind to be included on the page, this will be included by the regionalisation
       * snippet as long as auto redirection is turned on.
       */
      if (typeof window.geoip2 === 'undefined') {
        return;
      }
  
      return new Promise((resolve, reject) => {
        const onGeoIpSuccess = function (response) {
          const customerCountry = response.country.iso_code.toLowerCase();
          const customerProvince = response.subdivisions[0].iso_code;
          const customerZip = response.postal.code;
          resolve({ customerCountry, customerProvince, customerZip });
        };
  
        const onGeoIpError = function (error) {
          reject(error);
        };
  
        window.geoip2.city(onGeoIpSuccess, onGeoIpError);
      });
    }

    async setMsg(){
        const customerCountry = this.getThresholdCountry();
        const countryShipping = this.getShippingConfigForCountry(customerCountry);

        if (this.hasMlistFreeShipping() && this.isMlistFreeShippingCountry(customerCountry) && this.mlistFreeShippingMsg) {
          this.smallEl.classList.remove("visually-hidden");
          this.smallEl.innerHTML = `<span>${this.mlistFreeShippingMsg}</span> ${this.svg}`;
          if (this.progressEl) {
            this.progressEl.classList.remove('active');
          }
          if (this.shippingEstimateEnabled && countryShipping) {
            const mlistExp = this.hasFreeExpress(countryShipping.exp)
              ? this.toPresentmentAmount(countryShipping.exp)
              : null;
            this.showEdd(0, mlistExp);
          }
          return;
        }

        // Unmatched market/country: stay silent — never invent thresholds.
        if (!countryShipping || !Number.isFinite(countryShipping.min)) {
          return;
        }

        const freeShipMin = this.toPresentmentAmount(countryShipping.min);
        const freeShipExp = this.hasFreeExpress(countryShipping.exp)
          ? this.toPresentmentAmount(countryShipping.exp)
          : null;

        if (!Number.isFinite(freeShipMin)) {
          return;
        }

        var spendMore = Math.max(freeShipMin - this.cartTotal, 0);
        var expressSpend = this.hasFreeExpress(freeShipExp)
          ? Math.max(freeShipExp - this.cartTotal, 0)
          : null;

        if(this.shippingEstimateEnabled) this.showEdd(freeShipMin, freeShipExp);

        // Display the appropriate message
        this.smallEl.classList.remove("visually-hidden");
        if (this.progressSetting == "true") {
          if (spendMore === 0) {
            this.smallEl.innerHTML = `<span>You’ve unlocked <b>free</b> shipping.</span> ${this.svg}`;
            if (this.hasFreeExpress(freeShipExp) && expressSpend > 0) {
              let progress = (freeShipExp - expressSpend) / freeShipExp;
              this.smallEl.innerHTML = `<span>You’ve unlocked <b>free</b> shipping. Just <b>${Shopify.theme.helpers.formatMoney(expressSpend*100)}</b> more for free express.</span>${this.svg}`;
              this.progressEl.classList.add('active');
              this.progressEl.innerHTML = `
                <div class="free-shipping-indicator" style="width:${progress*100}%"></div>
              `;
            } else if (this.hasFreeExpress(freeShipExp) && expressSpend === 0 ) {
              this.smallEl.innerHTML = `<span>You’ve unlocked <b>free express</b> shipping.</span> ${this.svg}`;
              this.progressEl.classList.add('active');
              this.progressEl.innerHTML = `
                <div class="free-shipping-indicator" style="width:100%"></div>
              `;
            }
          } else {
            let progress = (freeShipMin - spendMore) / freeShipMin;
            this.progressEl.classList.add('active');
            this.progressEl.innerHTML = `
              <div class="free-shipping-indicator" style="width:${progress*100}%"></div>
            `;
            //   var formattedSpendMore = Shopify.formatMoney(spendMore, Shopify.money_format);          
            this.smallEl.innerHTML = `<span>Spend <b>${Shopify.theme.helpers.formatMoney(spendMore*100)}</b> more for <b>free</b> shipping.</span>${this.svg}`;
          }
        } else {
          if (spendMore === 0) {
            this.smallEl.innerHTML = '<span>Congratulations! You qualify for free shipping!</span>';
          } else {
            //   var formattedSpendMore = Shopify.formatMoney(spendMore, Shopify.money_format);
            this.smallEl.innerHTML = `<span>Spend ${Shopify.theme.helpers.formatMoney(spendMore*100)}  more to qualify for free shipping!</span>`;
          }
        }
    }

    async showEdd(freeShipMin, freeShipExp) {
      const stored = JSON.parse(sessionStorage.getItem("estimatedRate"));
      const today = new Date().toLocaleDateString();
      const hasExpress = this.hasFreeExpress(freeShipExp);
       // derive band from current cart + corrected thresholds
      const band =
        this.cartTotal < freeShipMin
          ? 'UNDER_MIN'
          : hasExpress && this.cartTotal < freeShipExp
            ? 'BETWEEN_MIN_AND_EXP'
            : hasExpress
              ? 'AT_LEAST_EXP'
              : 'AT_LEAST_MIN';

      if (
        stored && 
        stored.calculationDate === today && 
        stored.band === band
      ) {
        console.log("Skipping re-calculation, using cached value:", stored);
        this.shippingEstimateEl.innerHTML = this.buildEddHtml(stored);
        return;
      }

      let estimatedRate = await this.setEdd();
      if (!estimatedRate) return; 
      estimatedRate.threshold = this.cartTotal < freeShipMin
        ? freeShipMin
        : (hasExpress ? freeShipExp : freeShipMin);
      estimatedRate.band = band;

      estimatedRate.calculationDate = new Date().toLocaleDateString(); 
      sessionStorage.setItem("estimatedRate", JSON.stringify(estimatedRate));

      this.shippingEstimateEl.innerHTML = this.buildEddHtml(estimatedRate)

    }

    buildEddHtml(estimatedRate) {
      return `
      <p class="cart-drawer__shipping-estimate-title">Estimated Delivery: ${this.formatRange(estimatedRate.estimated_delivery_date.estimated_delivery_date_min, estimatedRate.estimated_delivery_date.estimated_delivery_date_max)}<span>${estimatedRate.price === '0.00' ? 'FREE' : Shopify.theme.helpers.formatMoney(estimatedRate.price) }</span></p>
      <p class="cart-drawer__shipping-estimate-subtitle">${estimatedRate.name} </p>
      `
    }

    async setEdd() {
      return Promise.all([
        this.shopifyShippingFetch(),
        this.aftershipFetch(this.generateAftershipData()),
      ])
      .then(([shopifyRates, aftershipDates]) => {
        console.log('Shopify rates:', shopifyRates);
        console.log('AfterShip dates:', aftershipDates);

        if (!shopifyRates) return;

        shopifyRates.forEach(rate => {
          rate.estimated_delivery_date = this.mapShippingRate(rate, aftershipDates, sessionStorage.getItem('customerLocationCode'));
        });

        let main_rate = this.selectMainRate(shopifyRates);

        return main_rate;
      })
      .catch((err) => {
        console.error('One of the shipping promises failed:', err);
      });
    }

    serialize(obj) {
      var str = [];
      for (var p in obj)
        if (obj.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }
      return str.join('&');
    }

    formatRange(minStr, maxStr) {
      const min = new Date(minStr);
      const max = new Date(maxStr);

      const minDay = min.toLocaleDateString('en-AU', { weekday: 'short', day: '2-digit', month: 'short' });
      const maxDay = max.toLocaleDateString('en-AU', { weekday: 'short', day: '2-digit', month: 'short' });

      return `${minDay} – ${maxDay}`;
    }

    aftershipEstimatedPickupPayload(processing_time) {
      return {
        order_time: this.aftershipFormatDate(),
        order_cutoff_time: '17:00:00',
        business_days: [1, 2, 3, 4, 5],
        order_processing_time: {
          unit: 'day',
          value: processing_time,
        },
      };
    }

    aftershipFormatDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      return formattedDateTime;
    }

    selectMainRate(rates) {
      if (!Array.isArray(rates) || rates.length === 0) return null;

      // helper: parse price safely
      const priceNum = (r) => Number.parseFloat(r?.price ?? '0') || 0;

      // helper: classify type by name
      const classify = (r) => {
        const name = (r?.name || '').toLowerCase();
        // treat "express" as express; treat "standard" or "regular" as standard
        const isExpress = /\bexpress\b/.test(name);
        const isStandard = /\b(standard|regular)\b/.test(name);
        // optionally ignore custom same-day windows, keep "shopify" ones as your std/express
        const isFromShopify = (r?.source || '').toLowerCase() === 'shopify';

        // Only consider Shopify rates for "main" selection
        if (!isFromShopify) return { type: null, isFree: false };

        return {
          type: isExpress ? 'express' : (isStandard ? 'standard' : null),
          isFree: priceNum(r) === 0
        };
      };

      // partition
      const classified = rates.map((r) => ({ rate: r, ...classify(r) }));

      // 1) free express
      const freeExpress = classified.find((x) => x.type === 'express' && x.isFree);
      if (freeExpress) return freeExpress.rate;

      // 2) free standard
      const freeStandard = classified.find((x) => x.type === 'standard' && x.isFree);
      if (freeStandard) return freeStandard.rate;

      // 3) cheapest standard
      const stds = classified.filter((x) => x.type === 'standard');
      if (stds.length) {
        stds.sort((a, b) => priceNum(a.rate) - priceNum(b.rate));
        return stds[0].rate;
      }

      // nothing matched: fall back to the overall cheapest Shopify rate
      const shopifyRates = classified.filter((x) => x.type !== null);
      if (shopifyRates.length) {
        shopifyRates.sort((a, b) => priceNum(a.rate) - priceNum(b.rate));
        return shopifyRates[0].rate;
      }

      // truly nothing usable
      return null;
    }

    shopifyShippingFetch() {
      const url = '/cart/shipping_rates.json';

      let country = sessionStorage.getItem('customerLocationCode');
      let province = sessionStorage.getItem('customerProvince');
      let zip = sessionStorage.getItem('customerZip');

      if(!country && !province && !zip) return;

      let paramsData = {
        'shipping_address[country]': country,
        'shipping_address[province]': province,
        'shipping_address[zip]': zip,
      };
      paramsData = this.serialize(paramsData);
      let body = {
        items: this.cart.items,
      };
      body = JSON.stringify(body);
      return fetch(`${url}?${paramsData}`)
      .then((response) => response.json())
      .then((response) => {
        return response.shipping_rates;
      });
    }

    aftershipFetch(data) {
      if (!data || !data.estimated_delivery_dates || !data.estimated_delivery_dates.length) {
        return Promise.resolve([]);
      }
      let aftership_endpoint = 'https://api.aftership.com/v4/estimated-delivery-date/predict-batch';
      return fetch(aftership_endpoint, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'aftership-api-key': window.theme.aftership.api,
        },
        body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then((response) => {
        console.log('response', response)
        return response.data.estimated_delivery_dates;
      })
      .catch((error) => {
        console.error(error);
      })
    }

    generateAftershipData() {
      // Warehouse address constants
      const AU_WAREHOUSE_ADDRESS = {
        country: "AUS",
        state: "NSW",
        city: "Turrella",
        postal_code: "2205"
      };

      const US_WAREHOUSE_ADDRESS = {
        country: "USA",
        state: "NJ",
        city: "Burlington",
        postal_code: "08016"
      };
      const locationCode = sessionStorage.getItem('customerLocationCode');
      let country = locationCode
        ? window.theme.regionalisationCountries.alpha2ToAlpha3(locationCode.toUpperCase())
        : null;
      let zip = sessionStorage.getItem('customerZip');
      // No geo yet (first visit / region detection pending): skip Aftership rather than crash.
      if (!country) {
        return { estimated_delivery_dates: [] };
      }
      const originAddress = Shopify.shop.includes('meshki-us.myshopify.com') ? US_WAREHOUSE_ADDRESS : AU_WAREHOUSE_ADDRESS;
      let estimated_delivery_dates_array = [];
      if (window.theme.aftership.auspost) {
        estimated_delivery_dates_array.push({
          slug: 'australia-post',
          service_type_name: 'Parcel Post',
          origin_address: originAddress,
          destination_address: {
            country: country,
            postal_code: zip,
          },
          package: 1,
          estimated_pickup: this.aftershipEstimatedPickupPayload(window.theme.aftership.processing_standard),
        });
        estimated_delivery_dates_array.push({
          slug: 'australia-post',
          service_type_name: 'Express Post',
          origin_address: originAddress,
          destination_address: {
            country: country,
            postal_code: zip,
          },
          package: 1,
          estimated_pickup: this.aftershipEstimatedPickupPayload(window.theme.aftership.processing_express),
        });
      }
      if (window.theme.aftership.dhl) {
        estimated_delivery_dates_array.push({
          slug: 'dhl',
          service_type_name: 'EXPRESS WORLDWIDE', 
          origin_address: originAddress,
          destination_address: {
            country: country,
            postal_code: zip,
          },
          package: 1,
          estimated_pickup: this.aftershipEstimatedPickupPayload(window.theme.aftership.processing_dhl),
        });
      }
      if (window.theme.aftership.dhl_int) {
        estimated_delivery_dates_array.push({
          slug: 'dhl-global-mail',
          service_type_name: 'PARCEL INTERNATIONAL DIRECT STANDARD',
          origin_address: originAddress,
          destination_address: {
            country: country,
            postal_code: zip,
          },
          package: 1,
          estimated_pickup: this.aftershipEstimatedPickupPayload(window.theme.aftership.processing_dhl_int),
        });
      }
      if (window.theme.aftership.omni) {
        estimated_delivery_dates_array.push({
          slug: 'omniparcel',
          service_type_name: 'Omni Parcel',
          origin_address: originAddress,
          destination_address: {
            country: country,
            postal_code: zip,
          },
          package: 1,
          estimated_pickup: this.aftershipEstimatedPickupPayload(window.theme.aftership.processing_omni),
        });
      }

      let data = {
        estimated_delivery_dates: estimated_delivery_dates_array,
      };
      console.log('aftership payload', data)
      return data;
    }

    mapShippingRate(rate, estimated_delivery_dates, country) {
      if (rate.name.toLowerCase().includes('standard') || rate.name.toLowerCase().includes('regular')) {
        if (window.theme.aftership.auspost.toLowerCase().includes(country)) {
          return estimated_delivery_dates.find(s => s.service_type_name === "Parcel Post");
        } else if (window.theme.aftership.omni.toLowerCase().includes(country)) {
          return estimated_delivery_dates.find(s => s.slug === "omniparcel");
        } else if (window.theme.aftership.dhl_int.toLowerCase().includes(country)) {
          return estimated_delivery_dates.find(s => s.slug === "omniparcel");
        } else {
          return;
        }
      } else if (rate.name.toLowerCase().includes('express')) {
        if (window.theme.aftership.auspost.toLowerCase().includes(country)) {
          return estimated_delivery_dates.find(s => s.service_type_name === "Express Post");
        } else if (window.theme.aftership.dhl.toLowerCase().includes(country)) {
          return estimated_delivery_dates.find(s => s.slug === "dhl");
        } else {
          return;
        }
      }
    }
}

customElements.define("free-shipping-message", FreeShippingMsg);



})();

/******/ })()
;